export class ActionProgressState {

  public progressPercent: number;
  public complete: boolean;
  public message: string;

}
